

import { createRoot } from 'react-dom/client';
import { Rav } from './rav';

createRoot(document.getElementById('root')!).render(<Rav />)

